/**
 * KallistÃ© Luxury Extensions - Main Site Scripts
 */
document.addEventListener('DOMContentLoaded', function () {

	// =============================================
// 1. SLIDER AUTOPLAY (INFINITE MARQUEE) WITH DRAG
// =============================================
function initSliderAutoplay() {
    var wrapper = document.getElementById('sliderWrapper');
    var slider = document.getElementById('categorySlider');

    if (!wrapper || !slider) return;

    // Clone nodes for seamless looping
    var originalCards = Array.from(slider.children);
    originalCards.forEach(function (card) {
        var clone = card.cloneNode(true);
        slider.appendChild(clone);
    });

    var speed = 1.0;
    var autoPlayTimer = null;
    var isDown = false;
    var startX;
    var scrollLeftPos;

    function autoPlay() {
        if (!isDown) {
            wrapper.scrollLeft += speed;
            // Seamless loop boundary check
            if (wrapper.scrollLeft >= slider.scrollWidth / 2) {
                wrapper.scrollLeft -= slider.scrollWidth / 2;
            } else if (wrapper.scrollLeft <= 0) {
                wrapper.scrollLeft += slider.scrollWidth / 2;
            }
        }
        autoPlayTimer = requestAnimationFrame(autoPlay);
    }

    // Start autoplay loop
    autoPlayTimer = requestAnimationFrame(autoPlay);

    function resumeAutoPlay() {
        cancelAnimationFrame(autoPlayTimer);
        autoPlayTimer = requestAnimationFrame(autoPlay);
    }

    // ==========================================
    // MOUSE DRAG (GRAB TO SCROLL) HANDLERS
    // ==========================================
    wrapper.addEventListener('mousedown', function (e) {
        isDown = true;
        wrapper.classList.add('is-dragging');
        startX = e.pageX - wrapper.offsetLeft;
        scrollLeftPos = wrapper.scrollLeft;
        cancelAnimationFrame(autoPlayTimer); // Pause marquee on drag start
    });

    wrapper.addEventListener('mouseleave', function () {
        if (isDown) {
            isDown = false;
            wrapper.classList.remove('is-dragging');
            resumeAutoPlay();
        }
    });

    wrapper.addEventListener('mouseup', function () {
        if (isDown) {
            isDown = false;
            wrapper.classList.remove('is-dragging');
            resumeAutoPlay();
        }
    });

    wrapper.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - wrapper.offsetLeft;
        var walk = (x - startX) * 1.5; // Scroll speed multiplier during drag
        wrapper.scrollLeft = scrollLeftPos - walk;

        // Maintain seamless infinite loop during manual drag
        if (wrapper.scrollLeft >= slider.scrollWidth / 2) {
            wrapper.scrollLeft -= slider.scrollWidth / 2;
            scrollLeftPos = wrapper.scrollLeft;
            startX = e.pageX - wrapper.offsetLeft;
        } else if (wrapper.scrollLeft <= 0) {
            wrapper.scrollLeft += slider.scrollWidth / 2;
            scrollLeftPos = wrapper.scrollLeft;
            startX = e.pageX - wrapper.offsetLeft;
        }
    });

    // ==========================================
    // TOUCH DRAG HANDLERS (Mobile / Tablets)
    // ==========================================
    wrapper.addEventListener('touchstart', function (e) {
        isDown = true;
        startX = e.touches[0].pageX - wrapper.offsetLeft;
        scrollLeftPos = wrapper.scrollLeft;
        cancelAnimationFrame(autoPlayTimer);
    }, { passive: true });

    wrapper.addEventListener('touchend', function () {
        if (isDown) {
            isDown = false;
            resumeAutoPlay();
        }
    });

    wrapper.addEventListener('touchmove', function (e) {
        if (!isDown) return;
        var x = e.touches[0].pageX - wrapper.offsetLeft;
        var walk = (x - startX) * 1.5;
        wrapper.scrollLeft = scrollLeftPos - walk;

        if (wrapper.scrollLeft >= slider.scrollWidth / 2) {
            wrapper.scrollLeft -= slider.scrollWidth / 2;
            scrollLeftPos = wrapper.scrollLeft;
            startX = e.touches[0].pageX - wrapper.offsetLeft;
        } else if (wrapper.scrollLeft <= 0) {
            wrapper.scrollLeft += slider.scrollWidth / 2;
            scrollLeftPos = wrapper.scrollLeft;
            startX = e.touches[0].pageX - wrapper.offsetLeft;
        }
    }, { passive: true });

    // Fallback hover pause when not actively dragging
    wrapper.addEventListener('mouseenter', function() {
        if (!isDown) cancelAnimationFrame(autoPlayTimer);
    });
    wrapper.addEventListener('mouseleave', function() {
        if (!isDown) resumeAutoPlay();
    });
}

	// =============================================
	// 2. TAB FILTERING (PALETTE GRID - NO ANIMATION)
	// =============================================
	function initTabFiltering() {
		var filterBtns = document.querySelectorAll('.palette-filters .filter-btn');
		var paletteCards = document.querySelectorAll('.palette-grid .palette-card');

		if (!filterBtns.length || !paletteCards.length) return;

		filterBtns.forEach(function (btn) {
			btn.addEventListener('click', function () {
				filterBtns.forEach(function (b) {
					b.classList.remove('active');
				});
				btn.classList.add('active');

				var filterValue = btn.getAttribute('data-filter');

				paletteCards.forEach(function (card) {
					var cardCategory = card.getAttribute('data-category');

					if (filterValue === 'all' || cardCategory === filterValue) {
						card.style.display = 'block';
						requestAnimationFrame(function () {
							card.style.opacity = '1';
							card.style.transform = 'translateY(0)';
						});
					} else {
						card.style.opacity = '0';
						card.style.transform = 'translateY(15px)';
						setTimeout(function () {
							card.style.display = 'none';
						}, 0);
					}
				});
			});
		});
	}

	// =============================================
	// 3. VIDEO CONTROLLER HELPER
	// =============================================
	function setupVideoToggle(containerSelector, videoId, btnId) {
		var container = document.querySelector(containerSelector);
		var video = document.getElementById(videoId);
		var btn = document.getElementById(btnId);

		if (!container || !video || !btn) return;

		function togglePlay() {
			if (video.paused) {
				video.play();
			} else {
				video.pause();
			}
		}

		btn.addEventListener('click', togglePlay);
		video.addEventListener('click', togglePlay);

		video.addEventListener('play', function () {
			container.classList.add('is-playing');
		});
		video.addEventListener('pause', function () {
			container.classList.remove('is-playing');
		});
		video.addEventListener('ended', function () {
			container.classList.remove('is-playing');
		});
	}

	// =============================================
	// 4. BEFORE / AFTER IMAGE SLIDER
	// =============================================
	function initBeforeAfterSliders() {
		var sliders = document.querySelectorAll('[data-ba-slider]');
		if (!sliders.length) return;

		sliders.forEach(function (slider) {
			var range = slider.querySelector('.ba-range');
			var beforeImgWrapper = slider.querySelector('.ba-before');
			var beforeImg = beforeImgWrapper ? beforeImgWrapper.querySelector('img') : null;
			var handle = slider.querySelector('.ba-handle');

			if (!range || !beforeImgWrapper || !beforeImg || !handle) return;

			function updateSliderWidth() {
				var containerWidth = slider.offsetWidth;
				beforeImg.style.width = containerWidth + 'px';
			}

			function handleInput(e) {
				var value = e.target.value;
				beforeImgWrapper.style.width = value + '%';
				handle.style.left = value + '%';
			}

			updateSliderWidth();
			window.addEventListener('resize', updateSliderWidth);
			range.addEventListener('input', handleInput);
		});
	}

	// =============================================
	// 5. MOBILE NAVIGATION SIDEBAR
	// =============================================
	function initMobileMenu() {
		var openBtn = document.getElementById('mobileMenuOpen');
		var closeBtn = document.getElementById('mobileMenuClose');
		var sidebar = document.getElementById('mainNav');
		var overlay = document.getElementById('sidebarOverlay');

		if (!sidebar || !overlay) return;

		function openMenu() {
			sidebar.classList.add('active');
			overlay.classList.add('active');
			document.body.style.overflow = 'hidden';
		}

		function closeMenu() {
			sidebar.classList.remove('active');
			overlay.classList.remove('active');
			document.body.style.overflow = '';
		}

		if (openBtn) openBtn.addEventListener('click', openMenu);
		if (closeBtn) closeBtn.addEventListener('click', closeMenu);
		if (overlay) overlay.addEventListener('click', closeMenu);
	}

	// =============================================
	// 6. BACK TO TOP BUTTON
	// =============================================
	function initBackToTop() {
		var backToTopBtn = document.getElementById('backToTop');
		if (!backToTopBtn) return;

		window.addEventListener('scroll', function () {
			if (window.scrollY > 300) {
				backToTopBtn.classList.add('visible');
			} else {
				backToTopBtn.classList.remove('visible');
			}
		});

		backToTopBtn.addEventListener('click', function () {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		});
	}

	// =============================================
	// 7. STICKY HEADER ON SCROLL
	// =============================================
	function initStickyHeader() {
		var mainHeader = document.querySelector('.site-header .main-header');
		if (!mainHeader) return;

		var scrollTrigger = 40;

		window.addEventListener('scroll', function () {
			if (window.scrollY > scrollTrigger) {
				mainHeader.classList.add('is-sticky');
			} else {
				mainHeader.classList.remove('is-sticky');
			}
		});
	}

	// =============================================
	// 8. ANIMATED COUNTER ON SCROLL
	// =============================================
	function initScrollCounter() {
		var statsSection = document.getElementById('statsRow');
		if (!statsSection) return;

		var counters = statsSection.querySelectorAll('.counter');
		var hasAnimated = false;

		function startCounter() {
			counters.forEach(function (counter) {
				var target = +counter.getAttribute('data-target');
				var speed = 2000;
				var startTime = null;

				function updateCount(currentTime) {
					if (!startTime) startTime = currentTime;
					var progress = currentTime - startTime;
					var currentCount = Math.min(Math.floor((progress / speed) * target), target);

					counter.innerText = currentCount;

					if (progress < speed) {
						requestAnimationFrame(updateCount);
					} else {
						counter.innerText = target;
					}
				}

				requestAnimationFrame(updateCount);
			});
		}

		var observer = new IntersectionObserver(function (entries) {
			if (entries[0].isIntersecting && !hasAnimated) {
				hasAnimated = true;
				startCounter();
			}
		}, {
			threshold: 0.5
		});

		observer.observe(statsSection);
	}

	// =============================================
	// 9. PLATFORM SELECTOR RADIO BUTTON HANDLER
	// =============================================
	function initPlatformSelector() {
		var platformBtns = document.querySelectorAll('.booking-section .platform-btn');
		if (!platformBtns.length) return;

		platformBtns.forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				if (e.target.tagName !== 'INPUT') {
					var radioInput = btn.querySelector('input[type="radio"]');
					if (radioInput) radioInput.checked = true;
				}
				platformBtns.forEach(function (b) {
					b.classList.remove('active');
				});
				btn.classList.add('active');
			});
		});
	}

	// =============================================
	// 10. OPEN DATE & TIME PICKERS ON BOX CLICK
	// =============================================
	function initPickerOpeners() {
		var inputs = document.querySelectorAll('.booking-section input[type="date"], .booking-section input[type="time"]');

		inputs.forEach(function (input) {
			input.addEventListener('click', function () {
				if (typeof input.showPicker === 'function') {
					input.showPicker();
				}
			});
		});
	}

	// =============================================
	// 11. BLOG SEARCH HANDLER (Real-Time + Submit)
	// =============================================
	function initBlogSearch() {
		var searchForm = document.getElementById('blogSearchForm');
		var searchInput = document.getElementById('blogSearchInput');

		if (!searchForm || !searchInput) return;

		function filterArticles() {
			var query = searchInput.value.trim().toLowerCase();
			var journalCards = document.querySelectorAll('.blog-section .journal-card');

			journalCards.forEach(function (card) {
				var title = card.querySelector('.card-title') ? card.querySelector('.card-title').textContent.toLowerCase() : '';
				var excerpt = card.querySelector('.card-excerpt') ? card.querySelector('.card-excerpt').textContent.toLowerCase() : '';
				var badge = card.querySelector('.badge') ? card.querySelector('.badge').textContent.toLowerCase() : '';

				if (title.includes(query) || excerpt.includes(query) || badge.includes(query)) {
					card.style.display = 'flex';
				} else {
					card.style.display = 'none';
				}
			});
		}
		searchInput.addEventListener('input', filterArticles);
		searchForm.addEventListener('submit', function (e) {
			e.preventDefault();
			filterArticles();
		});
	}

	// =============================================
	// 12. LIVE ELAPSED READING TIMER
	// =============================================
	function initReadTimeCalculator() {
		var articleContent = document.querySelector('.single-post-section .post-content');
		var readTimeContainer = document.querySelector('.single-post-section .read-time');

		if (!articleContent || !readTimeContainer) return;

		var elapsedMinutes = 0;

		// Initial render
		readTimeContainer.textContent = '1 MIN READ';

		// Update every 60,000 milliseconds (1 minute)
		setInterval(function () {
			elapsedMinutes++;
			var displayMinutes = elapsedMinutes + 1;
			readTimeContainer.textContent = displayMinutes + ' MIN READ';
		}, 60000);
	}

	// =============================================
	// 13. DRAG & DROP WITH LIVE IMAGE PREVIEW (FULLY FIXED)
	// =============================================
	function initDragAndDrop() {
		var dropzone = document.getElementById('hairDropzone');
		var fileInput = document.getElementById('hairSelfie');

		if (!dropzone || !fileInput) return;

		var title = dropzone.querySelector('.upload-title');
		var subtitle = dropzone.querySelector('.upload-subtitle');

		function renderPreview(file) {
			if (!file || !file.type.startsWith('image/')) return;

			var reader = new FileReader();
			reader.onload = function (e) {
				var existingPreview = dropzone.querySelector('.preview-image');
				if (!existingPreview) {
					existingPreview = document.createElement('img');
					existingPreview.className = 'preview-image';
					dropzone.querySelector('.dropzone-content').prepend(existingPreview);
				}

				existingPreview.src = e.target.result;
				dropzone.classList.add('has-preview');

				if (title) title.textContent = 'Image Selected: ' + file.name;
				if (subtitle) subtitle.textContent = 'Click or drag a new image to replace';
			};

			reader.readAsDataURL(file);
		}

		fileInput.addEventListener('change', function () {
			if (fileInput.files && fileInput.files.length > 0) {
				renderPreview(fileInput.files[0]);
			}
		});

	['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (eventName) {
			dropzone.addEventListener(eventName, function (e) {
				e.preventDefault();
				e.stopPropagation();
			}, false);
		});

	['dragenter', 'dragover'].forEach(function (eventName) {
			dropzone.addEventListener(eventName, function () {
				dropzone.classList.add('drag-over');
			}, false);
		});

	['dragleave', 'drop'].forEach(function (eventName) {
			dropzone.addEventListener(eventName, function () {
				dropzone.classList.remove('drag-over');
			}, false);
		});

		dropzone.addEventListener('drop', function (e) {
			var droppedFiles = e.dataTransfer.files;

			if (droppedFiles && droppedFiles.length > 0) {
				var dataTransfer = new DataTransfer();
				dataTransfer.items.add(droppedFiles[0]);
				fileInput.files = dataTransfer.files;

				renderPreview(droppedFiles[0]);
			}
		}, false);
	}

	// =============================================
	// 14. ANIMATED SEARCH OVERLAY MODULE
	// =============================================
	function initSearchModal() {
		var openBtn = document.getElementById('searchOpenBtn');
		var closeBtn = document.getElementById('searchCloseBtn');
		var overlay = document.getElementById('searchOverlay');
		var searchInput = document.getElementById('searchInputField');

		if (!openBtn || !closeBtn || !overlay) {
			console.warn('Search overlay elements missing from DOM');
			return;
		}

		function openSearch(e) {
			if (e) e.preventDefault();
			overlay.classList.add('active');
			document.body.style.overflow = 'hidden';
			if (searchInput) {
				setTimeout(function () {
					searchInput.focus();
				}, 100);
			}
		}

		function closeSearch() {
			overlay.classList.remove('active');
			document.body.style.overflow = '';
		}

		openBtn.addEventListener('click', openSearch);
		closeBtn.addEventListener('click', closeSearch);

		overlay.addEventListener('click', function (e) {
			if (e.target === overlay) {
				closeSearch();
			}
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && overlay.classList.contains('active')) {
				closeSearch();
			}
		});
	}

	// =============================================
	// 15. RESPONSIVE DROPDOWN ACCORDION MODULE
	// =============================================
	function initResponsiveDropdowns() {
		var dropdownParents = document.querySelectorAll('.main-nav .has-dropdown');
		dropdownParents.forEach(function (parent) {
			var toggleBtn = parent.querySelector('.dropdown-toggle');
			if (!toggleBtn) return;
			toggleBtn.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				var isActive = parent.classList.contains('active');
				dropdownParents.forEach(function (item) {
					item.classList.remove('active');
				});
				if (!isActive) {
					parent.classList.add('active');
				}
			});
		});
	}

	// =============================================
	// 16. AOS ANIMATION MODULE
	// =============================================
	function initAOSAnimation() {
		if (typeof AOS !== 'undefined') {
			AOS.init({
				duration: 1000,
				once: true,
				offset: 100
			});
		}
	}

	// =============================================
	// 17. GALLERY LIGHTBOX MODULE
	// =============================================
	function initGalleryLightbox() {
		var items = document.querySelectorAll('.gallery-item');
		var lightbox = document.getElementById('galleryLightbox');
		var lightboxImg = document.getElementById('lightboxImg');
		var closeBtn = document.getElementById('lightboxClose');

		if (!items.length || !lightbox || !lightboxImg) return;

		items.forEach(function (item) {
			item.addEventListener('click', function () {
				var fullSrc = item.getAttribute('data-src') || item.querySelector('img').src;
				lightboxImg.setAttribute('src', fullSrc);
				lightbox.classList.add('active');
				lightbox.setAttribute('aria-hidden', 'false');
			});
		});

		function closeLightbox() {
			lightbox.classList.remove('active');
			lightbox.setAttribute('aria-hidden', 'true');
			setTimeout(function () {
				lightboxImg.setAttribute('src', '');
			}, 300);
		}

		if (closeBtn) {
			closeBtn.addEventListener('click', closeLightbox);
		}

		lightbox.addEventListener('click', function (e) {
			if (e.target === lightbox) {
				closeLightbox();
			}
		});
	}

	// =============================================
	// EXECUTE ALL MODULES
	// =============================================
	initSliderAutoplay();
	initTabFiltering();
	setupVideoToggle('.crown-video-wrapper .video-card', 'crownVideo', 'crownPlayBtn');
	setupVideoToggle('.video-poster', 'hairTextureVideo', 'hairTexturePlayBtn');
	initBeforeAfterSliders();
	initMobileMenu();
	initBackToTop();
	initStickyHeader();
	initScrollCounter();
	initPlatformSelector();
	initPickerOpeners();
	initBlogSearch();
	initReadTimeCalculator();
	initDragAndDrop();
	initSearchModal();
	initResponsiveDropdowns();
	initAOSAnimation();
	initGalleryLightbox();
});